import { PillButton } from "../../../components/others/PillButton";
import { Practice } from "../../../services/TurnServices/Turns.type";

export type PracticesPillowsProps = {
  practices: Practice[];
  onClick: (practice: Practice) => void;
};

export const PracticesPillows: React.FC<PracticesPillowsProps> = ({
  practices,
  onClick,
}) => {
  return (
    <div className="mb-6 max-w-lg">
      <div className="flex flex-column gap-3 flex-wrap">
        {practices.map((practice) => (
          <PillButton
            key={`practice-${practice.id}`}
            text={practice.name}
            onClick={() => onClick(practice)}
          />
        ))}
      </div>
    </div>
  );
};
